// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__pHPVS","shake":"FloatingButton_shake__7uypG"};